<template>
    <div id="certificacao-bloco-pesquisa-filtros">
        <div class="filtros">
            <div class="bloco-pesquisa-filtros__container">
                <div class="bloco-pesquisa-filtros__barra-pesquisa">
                    <i class="el-icon-search"></i>
                    <input
                        v-model="pesquisa"
                        type="text"
                        :placeholder="
                            $tc(
                                'certification.messages.main_page.search_placeholder'
                            )
                        "
                        autocomplete="off"
                        @keyup.enter="aplicarFiltros"
                    />
                </div>
            </div>
            <section>
                <el-popover placement="bottom" width="600" trigger="click">
                    <el-button
                        class="button-outline"
                        icon="lyra-icon lyra-filtro"
                        name="filtro"
                        plain
                        slot="reference"
                    >
                        {{
                            $tc(
                                'certification.messages.main_page.advanced_filter_label'
                            )
                        }}
                    </el-button>
                    <el-form label-position="top">
                        <div class="filtros-avancados__titulo">
                            <p>
                                {{
                                    $tc(
                                        'certification.messages.main_page.advanced_filter_label'
                                    )
                                }}
                            </p>
                        </div>
                        <div class="filtros-avancados__collapse">
                            <el-collapse v-model="collapse" accordion>
                                <el-collapse-item
                                    v-for="(ativa, index) in ativas"
                                    :key="index"
                                    :title="ativa.nome"
                                    v-loading="carregandoCertificacaoTipo"
                                >
                                    <div class="filtros-avancados__opcoes">
                                        <el-checkbox
                                            class="filtros-avancados__tipo"
                                            v-for="resultados in ativa.resultadoCertificacaoTipo"
                                            v-model="resultados.check"
                                            :key="resultados.codigo"
                                            :label="resultados.codigo"
                                            :value="resultados.codigo"
                                            @change="aplicarFiltros"
                                        >
                                            {{ resultados.descricao }}
                                        </el-checkbox>
                                    </div>
                                </el-collapse-item>
                                <el-collapse-item
                                    :title="$tc('certification.words.state')"
                                    name="estado"
                                >
                                    <el-checkbox-group
                                        class="filtros-avancados__opcoes"
                                        v-model="estadoSelecionado"
                                        v-loading="carregandoestados"
                                    >
                                        <el-checkbox
                                            class="filtros-avancados__opcao"
                                            v-for="estado in estados"
                                            :label="estado.sigla"
                                            :key="estado.id"
                                            :value="estado.id"
                                            @change="aplicarFiltros"
                                        >
                                            {{ estado.sigla }}
                                        </el-checkbox>
                                    </el-checkbox-group>
                                </el-collapse-item>
                            </el-collapse>
                        </div>
                    </el-form>
                </el-popover>
            </section>
            <div class="exportar">
                <el-button
                    icon="el-icon-download"
                    type="primary"
                    @click="exportarRelatorioXlsx"
                >
                    {{ $tc('certification.words.export') }}
                </el-button>
            </div>
        </div>
        <div
            class="bloco-pesquisa-filtros__filtros-selecionados mt-3"
            v-if="tags.length"
        >
            <span class="filtros-selecionados__titulo">
                {{
                    $tc(
                        'certification.messages.main_page.selected_filters_label'
                    )
                }}:
            </span>
            <el-tag
                class="filtros-selecionados__tags"
                v-for="(tag, index) in tags"
                :key="index"
                type="success"
                @close="removerFiltro(tag)"
                closable
            >
                <span>{{ tag.nome || tag }}</span>
            </el-tag>
            <el-tag
                class="filtros-selecionados__limpar"
                v-if="tags.length"
                type="info"
                @click="limparFiltros"
            >
                {{ $tc('certification.words.clear_filters') }}
                <i class="el-icon-delete"></i>
            </el-tag>
        </div>
    </div>
</template>

<script>
import CertificacaoService from '@/services/CertificacaoService.js';
import LocalidadeService from '@/services/LocalidadeService';
export default {
    name: 'PesquisaFiltroCertificacao',
    data() {
        return {
            pesquisa: '',
            collapse: [],
            ativas: [],
            certificacaoTipoSelecionada: [],
            estadoSelecionado: [],
            totalizadorSelecionado: [],
            tags: [],
            estados: [],
            carregandoCertificacaoTipo: false,
            carregandoestados: false,
            filtro: {
                pesquisaFiltro: '',
                estadoId: [],
                certificacaoTipoStatus: {},
                territoriosAnalisados: false,
                areaPlantadaElegivel: false
            },
            params: {
                page: 0,
                size: 10,
                sort: 'dataCadastro',
                por: 'desc'
            },
            paginacao: {},
            certificacoesTabela: []
        };
    },
    mounted() {
        this.buscarCertificacaoAtiva();
        this.buscarEstados();
    },
    methods: {
        aplicarFiltros() {
            this.tags = [];
            if (this.estadoSelecionado.length) {
                this.tags.push(...this.estadoSelecionado);
            }

            if (this.totalizadorSelecionado.length) {
                this.tags.push(...this.totalizadorSelecionado);
            }

            const filtro = {
                pesquisa: this.obterPesquisa(),
                certificacaoTipoStatus: this.obterIdCertificacaoTipo(),
                estadoSelecionado: this.obterIdEstado()
            };

            this.$emit('emitFiltros', filtro, this.tags);
        },

        obterPesquisa() {
            if (!this.pesquisa) return '';
            return this.pesquisa;
        },

        async buscarCertificacaoAtiva() {
            try {
                this.carregandoCertificacaoTipo = true;
                const { data } =
                    await CertificacaoService.buscarTipoCertificacao();
                this.ativas = data.itens;
            } catch (error) {
                this.$notify.error({
                    message: this.$tc(
                        'certification.messages.errors.certification_fetch_error'
                    )
                });
            }
            this.carregandoCertificacaoTipo = false;
        },

        obterIdCertificacaoTipo() {
            if (!this.ativas.length) return {};

            var idCertificacaoTipo = {};
            this.certificacaoTipoSelecionada = [];

            const formatarNome = nome => `${nome}: `;

            this.ativas.forEach(c => {
                if (c.resultadoCertificacaoTipo.length) {
                    c.resultadoCertificacaoTipo.forEach(ct => {
                        if (ct.check) {
                            if (!idCertificacaoTipo[c.id]) {
                                idCertificacaoTipo[c.id] = [];
                            }

                            idCertificacaoTipo[c.id].push(ct.codigo);

                            const novoElemento = {
                                nome: formatarNome(c.nome) + ct.descricao,
                                id: ct.id
                            };

                            const elementoExistente =
                                this.certificacaoTipoSelecionada.find(
                                    el => el.id === novoElemento.id
                                );

                            if (!elementoExistente) {
                                this.certificacaoTipoSelecionada.push(
                                    novoElemento
                                );
                            }
                        }
                    });
                }
            });

            if (this.certificacaoTipoSelecionada.length) {
                const novosElementos = this.certificacaoTipoSelecionada.filter(
                    item => !this.tags.some(tag => tag.id === item.id)
                );
                this.tags.push(...novosElementos);
            }
            return idCertificacaoTipo;
        },

        removerFiltro(filtro) {
            let correspondenciaParcial = false;

            if (typeof filtro === 'string') {
                correspondenciaParcial = this.tags.some(
                    tag => tag.nome && tag.nome.includes(filtro)
                );
            } else if (filtro.nome) {
                correspondenciaParcial = this.tags.some(
                    tag => tag.nome && tag.nome.includes(filtro.nome)
                );
            }

            if (correspondenciaParcial) {
                filtro = this.tags.find(
                    tag => tag.nome && tag.nome.includes(filtro.nome || filtro)
                );
            } else if (
                filtro === 'TODOS' ||
                filtro === 'Territórios analisados'
            ) {
                filtro = 'Territórios analisados';
            } else if (
                filtro === 'AREA' ||
                filtro === 'Área plantio elegível'
            ) {
                filtro = 'Área plantio elegível';
            }

            this.tags.splice(this.tags.indexOf(filtro.nome || filtro), 1);
            this.desmarcarFiltroPopover(filtro);
            this.aplicarFiltros();
        },

        desmarcarFiltroPopover(filtro) {
            if (filtro.id) {
                this.ativas.forEach(c => {
                    if (c.resultadoCertificacaoTipo.length) {
                        c.resultadoCertificacaoTipo.forEach(ct => {
                            if (filtro.id === ct.id) {
                                ct.check = false;
                            }
                        });
                    }
                });
            }

            const indexEstadoSelecionado =
                this.estadoSelecionado.indexOf(filtro);
            if (indexEstadoSelecionado !== -1) {
                this.estadoSelecionado.splice(indexEstadoSelecionado, 1);
            }

            const indexTotalizadorSelecionado =
                this.totalizadorSelecionado.indexOf(filtro);
            if (indexTotalizadorSelecionado !== -1) {
                this.totalizadorSelecionado.splice(
                    indexTotalizadorSelecionado,
                    1
                );
            }
        },

        limparFiltros() {
            this.tags = [];
            this.pesquisa = '';
            this.certificacaoTipoSelecionada = [];
            this.estadoSelecionado = [];
            this.ativas.forEach(c => {
                if (c.resultadoCertificacaoTipo.length) {
                    c.resultadoCertificacaoTipo.forEach(ct => {
                        ct.check = false;
                    });
                }
            });
            this.totalizadorSelecionado = [];
            this.aplicarFiltros();
        },

        async buscarEstados() {
            try {
                this.carregandoestados = true;
                const { data } = await LocalidadeService.findEstados(false);

                this.estados = data;
            } catch (error) {
                this.$notify.error(
                    this.$tc('certification.messages.errors.states_fetch_error')
                );
            }
            this.carregandoestados = false;
        },
        obterIdEstado() {
            if (!this.estadoSelecionado) return [];
            return this.estadoSelecionado.map(sigla => {
                const estado = this.estados.find(
                    objeto => objeto.sigla === sigla
                );
                return estado ? estado.id : null;
            });
        },

        inserirFiltroTotalizador(dado) {
            if (!this.totalizadorSelecionado.includes(dado)) {
                if (dado === 'TODOS') {
                    this.totalizadorSelecionado.push('Territórios analisados');
                } else if (dado === 'AREA') {
                    this.totalizadorSelecionado.push('Área plantio elegível');
                } else {
                    const certificacaoEncontrada = this.ativas.find(obj =>
                        obj.nome.includes(dado)
                    );

                    if (certificacaoEncontrada) {
                        const certificacaoElegivel =
                            certificacaoEncontrada.resultadoCertificacaoTipo.find(
                                cert => cert.codigo === 'ELEGIVEL'
                            );

                        if (certificacaoElegivel) {
                            certificacaoElegivel.check = true;
                        }

                        this.obterIdCertificacaoTipo();
                    }
                }
            }

            this.tags = [
                ...new Set([...this.tags, ...this.totalizadorSelecionado])
            ];

            this.aplicarFiltros();
        },
        async exportarRelatorioXlsx() {
            this.carregandoTabela = true;

            this.filtro.pesquisaFiltro = this.obterPesquisa();
            this.filtro.estadoId = this.obterIdEstado();
            this.filtro.certificacaoTipoStatus = this.obterIdCertificacaoTipo();

            try {
                await CertificacaoService.exportarRelatorioXlsx(
                    this.filtro,
                    this.params
                );
            } catch (error) {
                this.$notify.error({
                    message: this.$tc(
                        'certification.messages.errors.export_error'
                    )
                });
            }
            this.carregandoTabela = false;
        }
    }
};
</script>

<style lang="scss" scoped>
body {
    overflow-y: hidden;
    overflow-x: hidden;
}

#certificacao-bloco-pesquisa-filtros {
    .filtros {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        gap: 10px;
    }

    .bloco-pesquisa-filtros__container {
        width: 100%;
        height: 42px;
        border-radius: 5px;
        background: var(--white);
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
        position: relative;
    }

    .filtros-data {
        box-shadow: 0px 0px 10px rgb(0 0 0 / 10%);
    }

    .input-data-cadastro {
        height: 43px !important;
        .el-input__inner {
            height: 43px !important;
        }
    }

    .bloco-pesquisa-filtros__barra-pesquisa {
        height: 100%;
        display: flex;
        justify-content: center;

        i.el-icon-search {
            color: var(--gray);
            font-size: 16px;
            display: flex;
            align-items: center;
            margin: 0 8px;
        }

        input {
            width: 100%;
            height: 100%;
            border: none;
            outline: none;
            border-radius: 5px;
            color: var(--primary);
        }
    }

    .bloco-pesquisa-filtros__filtros-selecionados {
        display: flex;
        align-items: center;
        gap: 4px;
        flex-wrap: wrap;
    }

    .filtros-selecionados__limpar {
        cursor: pointer;
    }

    .filtros-avancados__titulo {
        color: var(--primary);
        font-weight: bold;
    }
    .exportar {
        i {
            color: #ffffff;
        }
    }
}

.el-checkbox-group.filtros-avancados__opcoes,
.filtros-avancados__opcoes {
    font-size: 0;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
}
</style>
